/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchLookupTokenType} from '../api'

export const useMutationBatchLookupTokenType = createReactQueryMutationHook('batchLookupTokenType', batchLookupTokenType)
